import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ConsentField, Field, FormError, Honeypot, SelectInput, SubmitButton, TextArea, TextInput } from "@/components/inquiry/fields";
import { emailSchema } from "@/components/inquiry/schemas";
import { useLeadSubmit } from "@/components/inquiry/useLeadSubmit";
import { CONCERNS } from "@/lib/leadLabels";

export const EmailForm = ({ prefix = "email" }) => {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({
    resolver: zodResolver(emailSchema),
    mode: "onTouched",
    defaultValues: { name: "", email: "", phone: "", service: "", message: "", consent: false, website: "" },
  });
  const { submit, error } = useLeadSubmit("email");

  return (
    <form onSubmit={handleSubmit((v) => submit(v))} noValidate className="relative space-y-4" data-testid={`${prefix}-form`}>
      <Honeypot register={register} />
      <Field label="Name" required htmlFor={`${prefix}-name`} error={errors.name?.message}>
        <TextInput id={`${prefix}-name`} autoComplete="name" invalid={!!errors.name} {...register("name")} data-testid={`${prefix}-name`} />
      </Field>
      <Field label="E-Mail" required htmlFor={`${prefix}-email`} error={errors.email?.message}>
        <TextInput id={`${prefix}-email`} type="email" autoComplete="email" invalid={!!errors.email} {...register("email")} data-testid={`${prefix}-email`} />
      </Field>
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label="Telefon" htmlFor={`${prefix}-phone`} error={errors.phone?.message}>
          <TextInput id={`${prefix}-phone`} type="tel" inputMode="tel" autoComplete="tel" invalid={!!errors.phone} {...register("phone")} data-testid={`${prefix}-phone`} />
        </Field>
        <Field label="Leistung" htmlFor={`${prefix}-service`}>
          <SelectInput id={`${prefix}-service`} {...register("service")} data-testid={`${prefix}-service`}>
            <option value="">Bitte wählen</option>
            {CONCERNS.map((c) => <option key={c} value={c}>{c}</option>)}
          </SelectInput>
        </Field>
      </div>
      <Field label="Nachricht" required htmlFor={`${prefix}-message`} error={errors.message?.message}>
        <TextArea id={`${prefix}-message`} rows={4} placeholder="Was ist passiert? Wie können wir helfen?" invalid={!!errors.message} {...register("message")} data-testid={`${prefix}-message`} />
      </Field>
      <ConsentField id={`${prefix}-consent`} register={register} error={errors.consent?.message} />
      <FormError error={error} testId={`${prefix}-submit-error`} />
      <SubmitButton loading={isSubmitting} testId={`${prefix}-submit`}>Anfrage senden</SubmitButton>
    </form>
  );
};
